import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { aboutContent, siteInfo } from "../data/siteContent";
import styles from "./AboutSection.module.css";

export const AboutSection = () => (
  <div data-aos="fade-up" data-aos-delay="200" className={styles.container} id="about">
    <Container className="py-5">
      <Row className={styles.contentCard}>
        <h2 className={styles.title}>{aboutContent.title}</h2>
        <Col md={6}>
          <img src={aboutContent.image} alt="About Us" className={styles.image} />
          <div className={styles.infoSection}>
            <div className={styles.scheduleInfo}>
              <p>Join us for Church Service:</p>
              {aboutContent.serviceSchedule.map((service, index) => (
                <p key={index}>
                  {service.name} at {service.time}
                </p>
              ))}
            </div>
            <div className={styles.contactInfo}>
              <Row>
                <p>
                  <FaPhoneAlt />{" "}
                  <a href={`tel:${siteInfo.phone}`}>{siteInfo.phone}</a>
                </p>
                <p>
                  <FaEnvelope />{" "}
                  <a href={`mailto:${siteInfo.email}`}>{siteInfo.email}</a>
                </p>
                <p>
                  <IoLocationSharp /> {siteInfo.address}
                </p>
              </Row>
            </div>
          </div>
        </Col>
        <Col md={6} className="d-flex align-items-center">
          <div className={styles.missionBox}>
            <p className={styles.missionText}>{aboutContent.mission}</p>
          </div>
        </Col>
      </Row>
    </Container>
  </div>
);

export default AboutSection;
